export const romeFlorenceProgram = {
  programKey: 'rzym-i-florencja-sladami-antyku-i-renesansu',

  /* Podstawowe informacje wspólne dla sticky paska i katalogu. */
  title: 'Rzym i Florencja - Śladami antyku i renesansu',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Rzym i Florencja:',
  stickySubtitle: 'Śladami antyku i renesansu',

  pageUrl:
    'https://coolturystki.pl/wycieczki/rzym-i-florencja-sladami-antyku-i-renesansu',

  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/rzym-sladami-antyku-koloseum-mtyanvu5.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/rzym-sladami-antyku-koloseum-mtyanvu5.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Rzym i Florencja'],
    continent: 'Europa',
    categories: [],
    travelStyles: ['City break'],
    catalogPublishedAt: '2026-09-14',
  },

  /* Termin o ID 19: 25 - 28 lutego 2027. */
  tripIds: [19],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '19': {
      pilotId: 'krzysztof',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Kraków - Balice',

      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Krakowa',
          description:
            'Grupa może rozpocząć wspólną podróż na lotnisku Kraków-Balice i polecieć do Rzymu-Fiumicino. Dostępne jest również połączenie z Warszawy, a osoby wybierające inny lot mogą dołączyć do grupy na miejscu.',
        },
        hotel: {
          title: 'Hotel 4★ przy metrze i blisko Koloseum',
          description:
            'Zakwaterowanie w pokojach dwuosobowych, kilka kroków od stacji metra Manzoni i około 10 minut spacerem od Koloseum. Codziennie rano serwowane jest śniadanie w formie bufetu.',
        },
      },
    },
  },
}
